import React, { useState, useRef } from 'react';
import './Depoimentos.css';

// Import thumbnail images
import thumbnail1 from '../../../../assets/images/depoimento-1.jpg';
import thumbnail2 from '../../../../assets/images/depoimento-2.jpg';
import thumbnail3 from '../../../../assets/images/depoimento-3.jpg';
import thumbnail4 from '../../../../assets/images/depoimento-4.jpg';
import thumbnail5 from '../../../../assets/images/depoimento-5.jpg';
import thumbnail6 from '../../../../assets/images/depoimento-6.jpg';

const Depoimentos = () => {
  // Video data using YouTube links with matching thumbnails
  const videos = [
    {
      id: 1,
      youtubeId: '7qzuzEhtDv8',
      thumbnail: thumbnail1
    },
    {
      id: 2,
      youtubeId: 'mFYkNJzubF8',
      thumbnail: thumbnail2
    },
    {
      id: 3,
      youtubeId: 'E_Lw47PcQCE',
      thumbnail: thumbnail3
    },
    {
      id: 4,
      youtubeId: 'Y5MBepZ9F40',
      thumbnail: thumbnail4
    },
    {
      id: 5,
      youtubeId: '6NoLxAXI5Sw',
      thumbnail: thumbnail5
    },
    {
      id: 6,
      youtubeId: 'lzq2USCH90I',
      thumbnail: thumbnail6
    }
  ];

  const [playingVideo, setPlayingVideo] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const carouselRef = useRef(null);
  
  // Minimum swipe distance (in px)
  const minSwipeDistance = 50;

  // Function to handle touch start
  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  // Function to handle touch move
  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  // Function to handle touch end
  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;
    
    if (isLeftSwipe) {
      handleSwipe('right');
    } else if (isRightSwipe) {
      handleSwipe('left');
    }
    
    // Reset values
    setTouchStart(null);
    setTouchEnd(null);
  };

  // Function to handle swipe
  const handleSwipe = (direction) => {
    if (isAnimating) return;
    
    setIsAnimating(true);
    
    // Calculate the target index
    const step = direction === 'left' ? -1 : 1;
    
    // Update the currentIndex
    setCurrentIndex(prevIndex => {
      const newIndex = (prevIndex + step + videos.length) % videos.length;
      return newIndex;
    });
    
    // After the transition duration, clear the animation flag
    setTimeout(() => {
      setIsAnimating(false);
    }, 300);
  };

  // Function to play a video
  const playVideo = (videoId) => {
    if (playingVideo === videoId) {
      setPlayingVideo(null);
    } else {
      setPlayingVideo(videoId);
    }
  };

  return (
    <section id="depoimentos" className="depoimentos-section-mobile">
      <div className="container">
        <div className="section-header">
          <h2>Depoimentos</h2>
          <p>Ouça o que outros pais têm a dizer sobre nossa escola</p>
        </div>

        <div className="mobile-carousel-container">
          <div 
            className="mobile-carousel-track"
            ref={carouselRef}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
          >
            <div 
              className="mobile-carousel-inner"
              style={{
                transform: `translateX(${-currentIndex * 195 + 20}px)`, // 195px = card width (180px) + margin (15px)
                transition: isAnimating ? 'transform 0.3s ease-out' : 'none'
              }}
            >
              {videos.map((video) => (
                <div 
                  key={video.id} 
                  className="mobile-video-card"
                  onClick={() => playVideo(video.id)}
                >
                  {playingVideo === video.id ? (
                    <div className="mobile-video-player-container">
                      <iframe
                        className="mobile-video-player"
                        src={`https://www.youtube.com/embed/${video.youtubeId}?autoplay=1`}
                        title={`Depoimento ${video.id}`}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    </div>
                  ) : (
                    <div className="mobile-thumbnail-container">
                      <img 
                        src={video.thumbnail} 
                        alt={`Depoimento ${video.id}`} 
                        className="mobile-video-thumbnail" 
                      />
                      <div className="mobile-play-button">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8 5V19L19 12L8 5Z" fill="currentColor"/>
                        </svg>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
          
          {/* Pagination dots */}
          <div className="mobile-carousel-pagination">
            {videos.map((_, index) => (
              <span 
                key={index} 
                className={`pagination-dot ${index === currentIndex ? 'active' : ''}`}
                onClick={() => {
                  setCurrentIndex(index);
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Depoimentos; 